const CostContext = {
  ScanDown: '50.00',
  ScanDownAmount: 5000,
  ScanBalanceInitial: 20000,
  ScanBalanceFollowUp: 18500,
  ScanBalanceMultiple: 17500,
  ScanBalanceFamily: 17500,
  ScanBalanceFamilyMultiple: 15000,
  SubscriptionAmount: 44900,
  ImprintRemedy: 2000,
};

export function formatCentsToDollars(cents) {
  if (typeof cents !== 'number' || isNaN(cents)) {
    return '0.00';
  }
  return (cents / 100).toFixed(2);
}

export function formatCentsToDollarsNoDecimal(cents) {
  if (typeof cents !== 'number' || isNaN(cents)) {
    return '0';
  }
  return (cents / 100);
}

export default CostContext;